<template lang="pug">
v-list(expand flat active-class="fvMenuActive")
  template(v-for="navItem in navItems")
    ToolBarBaseItem(
      v-if="!navItem.submenu" 
      :key="navItem.name" 
      :item="navItem" 
      color="primary" 
      :drawer-status="drawerStatus"
    )
    v-tooltip(v-else :key="navItem.name"  right :disabled="!drawerStatus")
      template(#activator="{on, attrs}")
        v-list-group.list-group(
          v-bind="attrs"
          :key="navItem.name"
          no-action
          color="primary"
          :value="navItem.active"
          v-on="on"
        )
          template(#activator)
            v-list-item-title
              span.text-body-2.list-group-title {{ navItem.title }}
          template(#prependIcon)
            v-icon.list-group-icon {{ navItem.icon.value }}
          template(#appendIcon)
            v-icon.list-group-icon mdi-menu-down
          v-container.fill-height.pt-0(fluid)
            v-row(no-gutters)
              v-col(cols="auto")
                v-divider(vertical)
              v-col
                template(v-for="subNavItem in navItem.submenu")
                  ToolBarBaseItem(
                    v-if="!subNavItem.submenu" 
                    :key="subNavItem.name" 
                    :item="subNavItem" 
                    color="primary" 
                    list-level="1"
                    :drawer-status="drawerStatus"
                  )
                  v-list-group.list-level-2(v-else :key="subNavItem.name")
                    template(#activator)
                      v-list-item-title 
                        span.text-body-2.sub-list-group-title {{ subNavItem.title }}
                    template(#prependIcon)
                      v-icon.sub-list-group-icon {{ navItem.icon.value }}
                    template(#appendIcon)
                      v-icon.sub-list-group-icon mdi-menu-down
                    template(v-for="subSubNavItem in subNavItem.submenu")
                      ToolBarBaseItem(
                        :key="subSubNavItem.name"
                        list-level="2"
                        :drawer-status="drawerStatus" 
                        :item="subSubNavItem" 
                        color="primary" 
                      )
      span {{ navItem.title }}
</template>

<script>
import ToolBarBaseItem from "@/components/toolbar/ToolBarBaseItem.vue";
export default {
  name: "ToolBarList",
  components: {
    ToolBarBaseItem,
  },
  props: {
    navItems: {
      type: Array,
      default: () => [],
    },
    drawerStatus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedNavItem: null,
      buttonHovering: null,
      showTooltip: null,
    };
  },
  watch: {
    buttonHovering(newVal) {
      this.showToolTip = newVal;
    },
  },
};
</script>

<style lang="sass" scoped>
.list-group:hover
  background: none
  .list-group-icon, .list-group-title
    color: var(--v-primary-base)

.list-level-2:hover
  background: none
  .sub-list-group-icon, .sub-list-group-title
    color: var(--v-primary-base)

.list-group-icon, .sub-list-group-icon
  transform: rotate(0)
  color: var(--v-toolbarText-base)
  fill: var(--v-toolbarText-base)

.v-list.group--active .list-group-icon, .v-list.group--active .sub-list-group-icon
  transform: rotate(0)
  color: var(--v-primary-base)
  fill: var(--v-primary-base)
</style>
